import { PaginatedFrontendExperimentList } from '@rover/rsdk/src/apiClient/latest';
import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import httpContext from '@rover/rsdk/src/modules/Network/httpContext';
import type { Snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';
import { fullApiUrl } from '@rover/utilities/apiUrl';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const EXPERIMENTS_URL: string = fullApiUrl('frontend/experiments/');
export const get = async (): Promise<PaginatedFrontendExperimentList> => {
  const ai = getAxiosInstance();
  const params = new URLSearchParams();

  if (process.env.JS_ENV_CLIENT) {
    params.append('path', window.location.pathname);
  } else if (process.env.JS_ENV_SERVER) {
    const req = httpContext.getReq();
    params.append('path', req?.path || '');
  }

  try {
    const { data } = await ai.get<Snakeify<PaginatedFrontendExperimentList>>(EXPERIMENTS_URL, {
      params,
    });
    return camelize(data, true);
  } catch (e: any) {
    return DefaultAPIErrorHandler(e, 'There was an error while fetching experiments.');
  }
};
export default {
  get,
};
